import css from './FragmentInfoHeaderStep2.module.css';
import React, { ReactNode } from 'react';

interface FragmentInfoHeaderStep2Props {
    title?: string;
    id: number;
    description?: string;
    imgUrl: string;
    children?: ReactNode;
}

export const FragmentInfoHeaderStep2: React.FC<
    FragmentInfoHeaderStep2Props
> = ({ title, description, imgUrl, children }) => {
    return (
        <div className={css.fragmentInfo}>
            <div className={css.imgAndTitle}>
                <img
                    src={imgUrl}
                    alt="fragment-img"
                    className={css.fragmentImg}
                />
                <div className={css.fragmentInfoContainer}>
                    <div className={css.fragmentTitle}>{title}</div>
                    <div className={css.fragmentDescription}>{description}</div>
                </div>
            </div>

            {children}
        </div>
    );
};
